import { FieldFormatter } from '@facile-it/shark-morph/components'
import React from 'react'

export const footerPhrase = (): React.ReactNode => (
    <React.Fragment>
        Facile.it è un servizio offerto da Facile.it S.p.A. con socio unico, P.IVA 07902950968.
        <br />
        Il servizio di intermediazione assicurativa di Facile.it è gestito da Facile.it Broker di assicurazioni S.p.A.
        con socio unico, broker assicurativo regolamentato dall&apos;IVASS ed iscritto al RUI con numero B000480264,
        P.IVA 08007250965,{' '}
        <FieldFormatter.Color color="primary">
            <a href="mailto:facile.it-broker@pec.it">facile.it-broker@pec.it</a>
        </FieldFormatter.Color>
        . Per ulteriori informazioni, visita{' '}
        <FieldFormatter.Color color="primary">
            <a href="https://www.facile.it">www.facile.it</a>
        </FieldFormatter.Color>
        .
        <br />
        <br />
        Tutti i dati personali sono trattati nel rispetto della normativa in materia di protezione dei dati personali.
        Le informazioni trasmesse non hanno natura promozionale ma sono interpersonali o comunque costituiscono risposte
        a richieste dell&apos;interessato. Informativa privacy disponibile su{' '}
        <FieldFormatter.Color color="primary">
            <a href="https://www.facile.it">www.facile.it</a>
        </FieldFormatter.Color>
        . In caso di ricezione di questa comunicazione per errore, si prega di contattare il mittente e cancellare le
        informazioni da ogni dispositivo.
        <br />
        <br />
        Per qualsiasi informazione sui dati trattati o per l&apos;esercizio dei diritti ai sensi del Regolamento UE
        679/2016, è possibile scrivere a{' '}
        <FieldFormatter.Color color="primary">
            <a href="mailto:news@partner.facile.it">news@partner.facile.it</a>
        </FieldFormatter.Color>
        . Per non ricevere più questo tipo di e-mail da Facile.it, si prega di scrivere a{' '}
        <FieldFormatter.Color color="primary">
            <a href="mailto:news@partner.facile.it">news@partner.facile.it</a>
        </FieldFormatter.Color>{' '}
        con oggetto “Unsubscribe”.
    </React.Fragment>
)
